import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "./style/EndedTheme.css";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AuthContext } from "../auth/AuthProvider";

export default function EndedTheme() {
  const { id } = useParams();

  const [theme, setTheme] = useState({});

  const {
    user,
    googleUser,
    setPrevLocation,
    payed,
    googleUserAnswer,
    userAnswer,
    setLoading,
    apiUrl,
  } = useContext(AuthContext);

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    axios.get(`${apiUrl}/theme/${id}`).then((response) => {
      setTheme(response.data);
    });
  }, []);

  useEffect(() => {
    setLoading(false);
    if (!user && !googleUser) {
      localStorage.setItem("postLoginRedirect", location.pathname);
      navigate("/login", { replace: true });
    }
    // else {
    //   if (payed) {
    //     if (
    //       (userAnswer &&
    //         !userAnswer[0].reflectionVideoUrl.startsWith(
    //           "phase5/question5/",
    //         )) ||
    //       (googleUserAnswer &&
    //         !googleUserAnswer[0].reflectionVideoUrl.startsWith(
    //           "phase5/question5/",
    //         ))
    //     ) {
    //       navigate("/");
    //     }

    //   }
    // }
  }, [user, googleUser, userAnswer, id, navigate, setPrevLocation]);

  return (
    <section className="endedTheme">
      <div>
        <Link to={"/session"} className="back-btn" id="back">
          ❮
        </Link>
      </div>

      <div className="endedTheme-content">
        <span className="endedTheme-phase">Theme completed</span>

        <h1 className="endedTheme-title">{theme.title}</h1>

        <p className="endedTheme-message">
          You have taken a significant step in understanding yourself. Take a
          moment to let these insights settle.
        </p>

        <div className="endedTheme-orb">✓</div>

        <Link to={"/session"}>
          <button className="btn primary" id="returnBtn">
            🏠︎ Return to Themes
          </button>
        </Link>
        {/* <p className="endedTheme-sub">You can return anytime.</p> */}
      </div>
    </section>
  );
}
